const SESSION_STORAGE_KEY = "orator-pro-auth-session";

export function getSession() {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const rawSession = window.localStorage.getItem(SESSION_STORAGE_KEY);
    return rawSession ? JSON.parse(rawSession) : null;
  } catch (error) {
    return null;
  }
}

export function setSession(session) {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function clearSession() {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
}

export function getSessionToken() {
  const session = getSession();
  return session?.token || session?.sessionId || "";
}

export function getMemberships() {
  return getSession()?.memberships || [];
}

export function hasAnyRole(allowedRoles = []) {
  if (!allowedRoles.length) {
    return true;
  }
  const allowedRoleSet = new Set(allowedRoles);
  return getMemberships().some((membership) => allowedRoleSet.has(membership.role));
}

export function hasScopedRole(allowedRoles = [], scope = {}) {
  if (!allowedRoles.length) {
    return true;
  }

  const allowedRoleSet = new Set(allowedRoles);
  const eventScope = scope.eventId ? `event#${normalizeScopeValue(scope.eventId)}` : "";
  const universityScope = scope.universitySlug
    ? `university#${normalizeScopeValue(scope.universitySlug)}`
    : "";
  const memberships = getMemberships();
  const hasEventUniversityScope = Boolean(
    universityScope
    && memberships.some((membership) => membership.scope === universityScope)
  );

  return memberships.some((membership) => {
    if (!allowedRoleSet.has(membership.role)) {
      return false;
    }
    if (membership.scope === "global" && membership.role === "internal_admin") {
      return true;
    }
    return Boolean(
      (eventScope && hasEventUniversityScope && membership.scope === eventScope)
      || (universityScope && membership.scope === universityScope)
    );
  });
}

export function isAuthenticated() {
  return Boolean(getSessionToken());
}

export function canManageMessages(memberships = getMemberships()) {
  const hasUniversityMembership = memberships.some((membership) => membership.scope?.startsWith("university#"));
  return memberships.some((membership) => (
    (membership.role === "internal_admin" && membership.scope === "global")
    || (membership.role === "uni_admin" && (
      membership.scope?.startsWith("university#")
      || (hasUniversityMembership && membership.scope?.startsWith("event#"))
    ))
  ));
}

export function isGlobalInternalAdmin() {
  return getMemberships().some((membership) => membership.role === "internal_admin" && membership.scope === "global");
}

function normalizeScopeValue(value) {
  return String(value || "").trim().toLowerCase();
}
